import React from 'react';
import statisticList from '../../../utils/statisticsList';

function Statistics() {
  let appeals = 0;
  let trip = 0;
  let rescued = 0;
  let trained = 0;
  statisticList.forEach((element) => {
    appeals += element.appeals
    trip += element.trip;
    rescued += element.rescued;
    trained += element.trained;
  });
  function renderingSell(classDiv, year, appeals, trip, rescued, trained, key) {
    return (
      <div className={`statistics__headingTab ${classDiv}`} key={key}>
        <p className='statistics__sell'>{year}</p>
        <p className='statistics__sell statistics__sell_noDisplay'>{appeals === 0 ? '-' : appeals}</p>
        <p className='statistics__sell'>{trip}</p>
        <p className='statistics__sell'>{rescued}</p>
        <p className='statistics__sell statistics__sell_noDisplay'>{trained === 0 ? '-' : trained}</p>
      </div>
    );
  }
  return (
    <section className='statistics'>
      <h3 className='statistics__heading'>
        Статистические даные о работе МКУ «АСС Северодвинска»
      </h3>
      {renderingSell(
        '',
        'Год',
        'Принято сообщений ИДЦ',
        'Количество выездов ПСГ',
        'Спасено',
        'Подготовлено специалистов ГОЧС на Курсах ГО',
        0
      )}
      {statisticList.map((item) => {
        return renderingSell(
          'statistics__byYear',
          item.year,
          item.appeals,
          item.trip,
          item.rescued,
          item.trained,
          item.id
        );
      })}
      {renderingSell('', '', appeals, trip, rescued, trained, 9999)}
    </section>
  );
}

export default Statistics;
